import { render, staticRenderFns } from "./userSb-scenario-analyzer.vue?vue&type=template&id=a7dc1c50"
import script from "./userSb-scenario-analyzer.vue?vue&type=script&lang=ts"
export * from "./userSb-scenario-analyzer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports